export const SOCCER_LEVELS = [
    "Grassroots / Recreational",
    "Youth Elite / Academy",
    "OPDL",
    "League1 Canada (Pro-Am)",
    "University (U Sports)",
    "Professional (CPL)",
    "International",
    "Other"
];
